import { h } from 'preact';

export function ModalWrapper({
  children,
  wrapperCssClasses = null
}) {
  return (
    <div className={wrapperCssClasses} style={{ display: 'flex' }}>
      {children}
    </div>
  );
}
